module.exports = __webpack_public_path__ + "2318b69c61b8ea3a6866a277f7c1d279.pdf";